/**
 * sideNavDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

sideNavDirective.$inject = ['$mdMedia', '$transitions'];

export function sideNavDirective($mdMedia, $transitions) {
    return {
        scope: {
            collapsed: '=?collapsed',
        },
        transclude: true,
        //language=HTML
        template: `
            <div class="app-side-nav-inner">

                <div class="app-side-nav-toggle">
                    <md-button class="md-icon-button" ng-click="toggle($event)">
                        <md-icon>chevron_right</md-icon>
                    </md-button>
                </div>

                <div class="app-side-nav-content" ng-transclude>
                </div>
            </div>
        `,
        link: function(scope, element) {
            const $parent = element.parent();

            $parent.addClass('app-side-nav-parent');

            scope.$watch(
                () => $mdMedia('max-width: 960px'),
                collapsed => {
                    scope.collapsed = collapsed;
                },
            );

            $transitions.onBefore({}, onTransitionBefore);

            onTransitionBefore.$inject = ['$transition$'];

            function onTransitionBefore(transition) {
                const from = transition.$from();
                const to = transition.$to();

                if (!from.is(to)) {
                    element.removeClass('is-open');
                }
            }

            scope.toggle = function() {
                element.toggleClass('is-open');
            };
        },
    };
}
